<template>
  <div>
    <v-card class="mx-auto" tile v-if="showCreateSurvey">
      <v-form ref="form" v-model="formIsValid">
        <v-text-field v-model="nameSurvey" :rules="[rules.required]" label="Name survey"></v-text-field>
        <v-btn color="primary" :disabled="!formIsValid" type="submit" @click="createSurvey">submit</v-btn>
      </v-form>
    </v-card>
    <v-card class="mx-auto" tile v-else-if="showAddEmail">
      <v-text-field v-model="emailToAdd" :rules="[rules.required]" label="Email address"></v-text-field>
      <v-btn color="primary" :disabled="!formIsValid" type="submit" @click="addEmailAddress">submit</v-btn>
    </v-card>
    <v-card class="mx-auto" tile v-else>
      <v-container>
        <v-row class="pa-2" no-gutters v-for="item in clientInfo" v-bind:key="item.key">
          <v-col class="pa-2" cols="12" sm="4"></v-col>
          <v-col class="pa-2" cols="12" sm="4">{{ item.key }}</v-col>
          <v-col class="pa-2" cols="12" sm="4" v-if="item.type === 'survey'">
            <v-btn class="mr-3" @click="$router.push(`/clients/${id}/surveys/${item.key}`)">edit survey</v-btn>
            <v-btn v-if="item.value > 0" @click="playSurvey(item.key)">play survey</v-btn>
          </v-col>
          <v-col class="pa-2" cols="12" sm="4" v-else>{{ item.value }}</v-col>
        </v-row>
        <v-row class="pa-2">
          <v-col class="pa-2" cols="12" sm="4"></v-col>
          <v-col class="pa-2" cols="12" sm="4"></v-col>
          <v-col class="pa-2" cols="12" sm="4">
            <v-btn class="primary mr-3" @click="showCreateSurvey = true">Add survey</v-btn>
            <v-btn class="primary" @click="showAddEmail = true">Add email</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import { clientService } from '@/services/client';
  import { webSocketService } from '@/services/question';

  export default {
    name: 'ClientDetails',
    data() {
      return {
        id: null,
        clientInfo: null,
        nameSurvey: null,
        emailToAdd: null,
        showCreateSurvey: false,
        showAddEmail: false,
        formIsValid: true,
        rules: {
          required: value => !!value || 'Verplicht veld',
        },
      };
    },
    methods: {
      clientConvertToList(clientDetails) {
        const listOfValues = [];
        Object.keys(clientDetails)
          .filter(e => e !== 'surveys')
          .map(e => {
            return { 'type': 'generic', 'key': e, 'value': clientDetails[e] };
          })
          .filter(e => e.value)
          .forEach(e => listOfValues.push(e));

        const surveys = clientDetails['surveys'];
        Object.keys(surveys).map(e => {
          return { 'type': 'survey', 'key': e, 'value': surveys[e].length };
        })
          .forEach(e => listOfValues.push(e));

        return listOfValues;
      },
      createSurvey() {
        clientService.createSurvey(this.$route.params.id, this.nameSurvey)
          // eslint-disable-next-line no-unused-vars
          .then(e => {
            this.loadClient();
            this.showCreateSurvey = false;
            this.nameSurvey = null;
          })
          .catch(e => console.log('error: ', e));
      },
      addEmailAddress() {
        clientService.addEmailAddress(this.$route.params.id, this.emailToAdd)
          // eslint-disable-next-line no-unused-vars
          .then(e => {
            this.loadClient();
            this.showAddEmail = false;
            this.emailToAdd = null;
          });
      },
      loadClient() {
        this.id = this.$route.params.id;
        clientService.resolveClient(this.id).then(e => this.clientInfo = this.clientConvertToList(e.data))
          .catch(e => console.log('error: ', e));
      },
      playSurvey(surveyId) {
        clientService.resolveCookie(this.id, surveyId)
          // eslint-disable-next-line no-unused-vars
          .then(e => {
            webSocketService.reconnectWebsocket();
          })
          .catch(e => console.log('error: ', e));
      },
    },
    created() {
      this.loadClient();
    },
  };
</script>

<style scoped>

</style>